import axios from "axios";
import Config from "src/config";

const v2_actionCalendarioListaEventos = (clienteId, querys) => {
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/${clienteId}/calendario/eventos/lista${querys ? querys : ''}`
    });
};
export default v2_actionCalendarioListaEventos;
